import Registration from './Registration-compose';

export default Registration;
